import { UtilService } from "../../services/shared/UtilService";
import { formatDate } from "../../constants/helper";
import { msgTypes } from "../../constants/msgTypes";
import { useSweetAlert } from "../../services/customHooks/useSweetAlert";
import { Switch } from "@mui/material";
type UserInfoCardsProps = {
  username: string;
  rolename: string;
  branch: string;
  id: string;
  email: string;
  mobile: string;
  status: string;
  createdAt?: any;
  createdBy?: string;
  className?: string;
  handleEditClick: () => void;
  employeeCode?: string;
  getUserList: () => void;
};

const UserInfoCards = ({
  username,
  rolename,
  branch,
  id,
  email,
  mobile,
  status,
  createdAt,
  className = "",
  createdBy,
  handleEditClick,
  employeeCode,
  getUserList,
}: UserInfoCardsProps) => {
  const { showSuccess, showError, showInfo, showConfirm } = useSweetAlert();
  const sendWelcomeEmail = async () => {
    const payload = {
      email: email,
    };
    try {
      const response = await UtilService.sendWelcomeEmail(payload);
      if (response?.statusMsg === msgTypes.SUCCESS.msg) {
        showSuccess("Email sent successfully");
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  const handleToggleBtn = () => {
    if (status === "active") {
      showConfirm(
        "",
        `Are you sure you want to deactivate ${username} ? `
      ).then((result) => {
        if (result?.isConfirmed) {
          const payload = {
            status: "inactive",
          };
          editUserStatus(payload, id ?? "");
        }
      });
    } else {
      showConfirm("", `Are you sure you want to activate ${username} ? `).then(
        (result) => {
          if (result?.isConfirmed) {
            const payload = {
              status: "active",
            };
            editUserStatus(payload, id ?? "");
          }
        }
      );
    }
  };

  const editUserStatus = async (payload: {}, id: string) => {
    try {
      const res = await UtilService.EditUser(payload, id);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        showSuccess("Success!", "User has been updated successfully.");
        getUserList();
      }
    } catch (error) {
      console.error("An error occurred createUser:", error);
    }
  };
  return (
    <tr className="align-middle text-center">
      <td className="text-capitalize fw-medium ">
        <div className="sort text-capitalize">{username ?? "-"}</div>
      </td>
      <td>
        <div className="sort">{email ?? "-"}</div>
      </td>
      <td>
        <div className="sort">{mobile ?? "-"}</div>
      </td>
      <td>
        <div className="sort">{employeeCode ?? "-"}</div>
      </td>
      <td>
        <div className="sort">{formatDate(createdAt) ?? "-"}</div>
      </td>
      <td>
        <div className="sort">{createdBy ?? "-"}</div>
      </td>
      <td>
        <span
          className="badge bg-outline-primary text-dark cursor-pointer"
          onClick={sendWelcomeEmail}
        >
          <i className="fa-solid fa-share me-1"></i>
          Send
        </span>
      </td>
      <td>
        {/* <div
          className={`
            text-decoration-underline fw-semibold sort
            ${
              status === "active"
                ? "text-success fw-bold"
                : status === "Pending"
                ? "text-warning"
                : "text-muted"
            }
          `}
        >
          {status}
        </div> */}
        <div className="sort" style={{ height: "4px" }}>
          <Switch
            checked={status === "active"}
            onClick={() => handleToggleBtn()}
            size="small" // optional: keeps it compact
          />
        </div>
      </td>
      <td>
        <span
          className="badge badge-sm badge-warning badge-outline cursor-pointer"
          onClick={handleEditClick}
        >
          <i className="fa-solid fa-pen-to-square"></i>
        </span>
      </td>
    </tr>
  );
};

export default UserInfoCards;
